import {
  nullableRoomMixerId,
  RoomId,
  roomId,
  RoomMixerId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerVO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerVO.validationSchema()
  );

  constructor(readonly value: RoomMixer) {
    JsonSchemaValidator.assert(RoomMixerVO.validation, value);
  }

  toJSON() {
    return this.value;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "mixerId", "roomMixerStart", "roomMixerStarted"],
      properties: {
        roomId,
        mixerId: nullableRoomMixerId,
        roomMixerStart: {
          type: "boolean"
        },
        roomMixerStarted: {
          type: "boolean"
        }
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerJson extends RoomMixer {}

interface RoomMixer {
  roomId: RoomId;
  mixerId: null | RoomMixerId;
  roomMixerStart: boolean;
  roomMixerStarted: boolean;
}
